import { FormField } from "@coval/ui"
import { addDays } from "date-fns"

import { DateRangeFilterButton } from "@/components/date-range/DateRangeFilterButton"

import {
  pacificToday,
  reportRange,
  reportRangeChange,
  reportRangeError,
} from "../../utils/reportPeriods"
import type { ReportConfig } from "../../utils/reportTypes"

export function ReportPeriodPicker({
  config,
  onChange,
  defaultEnd,
  disabled,
}: {
  config: ReportConfig
  onChange: (config: ReportConfig) => void
  defaultEnd?: string
  disabled: boolean
}) {
  const today = () => new Date(`${pacificToday()}T12:00:00`)
  const presets = [
    {
      label: "Today",
      getValue: () => {
        const current = today()
        return { start: current, end: current }
      },
    },
    {
      label: "Yesterday",
      getValue: () => {
        const current = addDays(today(), -1)
        return { start: current, end: current }
      },
    },
    ...[7, 30].map((days) => ({
      label: `Last ${days} days`,
      getValue: () => {
        const current = today()
        return {
          start: addDays(current, 1 - days),
          end: current,
        }
      },
    })),
  ]
  return (
    <FormField
      label="Date range"
      description="Pacific calendar dates, including both selected days. Compared with the previous period of the same length. Today’s data is still accumulating."
    >
      {/* The trigger names itself with the applied range. */}
      <DateRangeFilterButton
        value={reportRange(config, defaultEnd)}
        dateOnly
        presets={presets}
        disabled={disabled}
        customRangeError={reportRangeError(config)}
        onRangeChange={({ start, end }) =>
          onChange({ ...config, ...reportRangeChange(start, end) })
        }
      />
    </FormField>
  )
}
